/** An instant as "5m ago", the full local date-time on hover (a description, not the name: lesson
 *  "A string Tooltip title becomes the child's aria-label"). */
import { Box, Tooltip } from '@mui/material';

import { formatDate, formatRelativeTime } from '@/utils/format';

export function When({ iso }: { iso: string | null | undefined }) {
  if (!iso) return <>—</>;
  return (
    <Tooltip describeChild title={formatDate(iso)}>
      <Box component="span" sx={{ textDecoration: 'underline dotted', textUnderlineOffset: 3 }}>
        {formatRelativeTime(iso)}
      </Box>
    </Tooltip>
  );
}
